import { MediaType } from '@/types';

const getMediaTypeFromString = (type: string): MediaType => {
  if (type === 'video') return MediaType.VIDEO;
  if (type === 'audio') return MediaType.AUDIO;
  return MediaType.IMAGE;
};

export default getMediaTypeFromString;
